import React from 'react';
import { motion, HTMLMotionProps } from 'framer-motion';
import { cn } from '../../lib/utils';
interface FadeInProps extends HTMLMotionProps<'div'> {
  delay?: number;
  direction?: 'up' | 'down' | 'left' | 'right';
  fullWidth?: boolean;
}
export function FadeIn({
  children,
  className,
  delay = 0,
  direction = 'up',
  fullWidth = false,
  ...props
}: FadeInProps) {
  const directions = {
    up: {
      y: 20,
      x: 0
    },
    down: {
      y: -20,
      x: 0
    },
    left: {
      x: 20,
      y: 0
    },
    right: {
      x: -20,
      y: 0
    }
  };
  return <motion.div initial={{
    opacity: 0,
    ...directions[direction]
  }} whileInView={{
    opacity: 1,
    x: 0,
    y: 0
  }} viewport={{
    once: true,
    margin: '-50px'
  }} transition={{
    duration: 0.5,
    delay,
    ease: 'easeOut'
  }} className={cn(fullWidth ? 'w-full' : '', className)} {...props} data-id="element-143">
      {children}
    </motion.div>;
}